import {User} from "./user";

export class Comment {
    date:number;
    id:number;
    owner:User;
    text:string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/model/comment.ts